

























import { createComponent, ref, computed } from '@vue/composition-api';
import UIInput from '@sbvr/lbe-ui/UIInput.vue';
import UIButton from '@sbvr/lbe-ui/UIButton.vue';
import UICheckbox from '@sbvr/lbe-ui/UICheckbox.vue';
import { passwordChangeMutation } from '@/core/actions/login';
import useFlash from '@sbvr/lbe-web-panel/flash';
import router from '@/core/routes';
import BaseLayout from './layouts/BaseLayout.vue';

export default createComponent({
  name: 'PasswordChangeRoute',
  components: {
    UIInput,
    UIButton,
    UICheckbox,
    BaseLayout
  },
  props: {
    email: {
      type: String,
      required: true,
    },
    token: {
      type: String,
      required: true,
    },
  },
  setup (props) {
    const password = ref('');
    const passwordConfirmation = ref('');
    const { showFlash } = useFlash();
    async function onRequestLink () {
      try {
        await passwordChangeMutation({
          ...props,
          password: password.value,
          passwordConfirmation: passwordConfirmation.value,
        });
        showFlash({
          type: 'success',
          message: 'Your password has been successfully changed',
        });
        router.push({ name: 'home' });
      } catch (e) {
        console.log(e.message);

        showFlash({
          type: 'error',
          message: 'Error',
        });
      }
    }
    const valid = computed(() => {
      return password.value && password.value === passwordConfirmation.value;
    });
    return {
      valid,
      password,
      passwordConfirmation,
      onRequestLink,
    };
  },
});
